import { Capacitor, registerPlugin } from '@capacitor/core';
import { createSessionStorage, SecureSessionStore } from '../utilities/session';
const secure = registerPlugin<SecureSessionStore>('SecureSession');
export const sessionStorage = createSessionStorage(Capacitor.isNativePlatform(), secure, { removeItem: (key) => localStorage.removeItem(key) });
